import { memo } from 'react';
import type { ILayerBehavior, ILayerProps } from '@/version-types';

type Props = {
    behavior: ILayerBehavior;
    layer: ILayerProps;
    iconRenderVersion: number;
};

/**
 * iconRenderVersion 变化时重新调用图层 behavior，获取最新的运行时资源。
 */
export const HierarchyThumbnail = memo(({ behavior, layer, iconRenderVersion }: Props) => {
    void iconRenderVersion;
    const icon = behavior.getMenuOverlapIcon(layer);

    return <div className="hierarchy-item__thumbnail">{icon}</div>;
});
